import { ICameraCCTV, IClient, IProject } from '@api/models';
import { getAllCctvCameras } from '@api/services/cctv-camera.service';
import useDataQuery from '@hooks/use-data-query';
import { useCallback, useMemo, useState } from 'react';

const useLiveCameraListData = () => {
    const [filterValue, setFilterValue] = useState('ALL');

    const changeFilterValue = useCallback(
        (val: string | number) => {
            // setIsSortable(false);
            setFilterValue(val as string);
        },
        [setFilterValue]
    );

    // const [searchParams, setSearchParams] = useSearchParams();

    // let searchQueryString = searchParams.get('search') || '';
    // const [searchValue, setSearchValue] = useState(searchQueryString);

    // const setSearchQuery = (value: string) => {
    //     setSearchValue(value);

    //     if (value) {
    //         searchParams.set('search', value);
    //     } else {
    //         searchParams.delete('search');
    //     }

    //     setSearchParams(searchParams);
    // };

    const liveCameraListQuery = useDataQuery(['live-camera'], () => getAllCctvCameras());
    // const { isLoading, isOffline, isOnline, setOnline, setOffline, status } = useCctvStatus();
    // const { isLoading, isOffline, isOnline, status } = useCctvStatusChecker(cctvCamera.streamingUrl);

    const allLiveCameras = useMemo(() => {
        if (liveCameraListQuery.isLoading) return [];

        const _liveCamera = liveCameraListQuery.data;

        const uniqueCamerasMap = new Map<string, ICameraCCTV>();
        const camerasWithoutQliveUnit: ICameraCCTV[] = [];

        // Group cameras by qLiveUnit
        _liveCamera.forEach((camera: ICameraCCTV) => {
            if (camera.qLiveUnit) {
                if (!uniqueCamerasMap.has(camera.qLiveUnit)) {
                    uniqueCamerasMap.set(camera.qLiveUnit, camera);
                }
            } else {
                camerasWithoutQliveUnit.push(camera);
            }
        });

        // Combine unique cameras with those without qLiveUnit
        const combined = [...Array.from(uniqueCamerasMap.values()), ...camerasWithoutQliveUnit];

        // Sort cameras: first by client.name, then by project.name if client.name is the same,
        // and finally by camera.name if both client.name and project.name are the same
        return combined.sort((a, b) => {
            const nameA = (a.client as IClient)?.name?.toLowerCase() || '';
            const nameB = (b.client as IClient)?.name?.toLowerCase() || '';

            // Compare client names first
            if (nameA === nameB) {
                // If client names are the same, compare by project.name
                const projectNameA = (a.project as IProject)?.name?.toLowerCase() || '';
                const projectNameB = (b.project as IProject)?.name?.toLowerCase() || '';

                if (projectNameA === projectNameB) {
                    // If project names are the same, compare by camera.name
                    const cameraNameA = a.name?.toLowerCase() || '';
                    const cameraNameB = b.name?.toLowerCase() || '';
                    return cameraNameA.localeCompare(cameraNameB);
                }

                return projectNameA.localeCompare(projectNameB);
            }

            // If client names differ, sort by client name
            return nameA.localeCompare(nameB);
        });
    }, [liveCameraListQuery.isLoading, liveCameraListQuery.data, filterValue]);

    // const filterOptions = useMemo(() => {
    //     if (liveCameraListQuery.isLoading) return [];

    //     const liveCameras = liveCameraListQuery.data;

    //     const _filterOptions = [
    //         {
    //             label: `All (${liveCameras.length})`,
    //             value: FilterValues.ALL,
    //         },
    //         {
    //             label: `Online (${liveCameras.filter((row) => row.isOnline).length})`,
    //             value: FilterValues.ONLINE,
    //         },
    //         {
    //             label: `Offline (${liveCameras.filter((row) => row.isOffline).length})`,
    //             value: FilterValues.OFFLINE,
    //         },
    //     ];

    //     return _filterOptions;
    // }, [liveCameraListQuery.isLoading, liveCameraListQuery.data]);

    // const filteredCamera = useMemo(() => {
    //     let _Cameras = resllerCameraListQuery?.data?.rows;
    //     const val = searchValue.toLowerCase();

    //     if (val) {
    //         _Cameras = _Cameras?.filter((row) => {
    //             let flag = row.name.toLowerCase().includes(val);

    //             flag = flag || row._id.toLowerCase().includes(val);
    //             console.log('flag', flag);

    //             return flag;
    //         });
    //     }

    //     return _Cameras;
    // }, [resllerCameraListQuery.isLoading, resllerCameraListQuery.data, searchValue]);

    return {
        allLiveCameras,
        isLoading: liveCameraListQuery.isLoading,
        changeFilterValue,
        // filterOptions,
        filterValue,
    };
};

export default useLiveCameraListData;
